import { minBy } from "lodash";
import { useCurrentLocationByIp } from "../../../../hooks";

export type FlightSummary = {
    city: string;
    state?: string | null;
    code: string;
    price?: number | null;
    displayName: string;
};

export const useClosestAvailableGateway = (
    availableFlightPackages: FlightSummary[],
) => {
    const locationData = useCurrentLocationByIp();
    if (!locationData.checkedLocation) {
        return { isLoading: true };
    }

    const closestRoundtripFlight = () => {
        // Filter flights in the same state
        const flightsInState = availableFlightPackages.filter(
            ({ state }) => state === locationData.region_code,
        );

        if (!flightsInState.length) {
            return undefined;
        }

        // Find flights with gateways in the user's city
        const cityFlights = flightsInState.filter(
            ({ city }) => city === locationData.city,
        );

        // If we have flights in the city, return the cheapest one
        if (cityFlights.length > 0) {
            return (
                minBy(
                    cityFlights.filter((flight) => flight.price),
                    (flight) => flight.price,
                ) ?? cityFlights[0]
            );
        }

        return (
            minBy(
                flightsInState.filter((flight) => flight.price),
                (flight) => flight.price,
            ) ?? flightsInState[0]
        );
    };
    return {
        closestRoundtripFlightSummary: closestRoundtripFlight(),
        isLoading: !locationData.checkedLocation,
    };
};
